import { TiTick } from "react-icons/ti";

export const ActivitySummary = ({ data, ActivityName, StartDay, EndDay }) => {
  // let sampleData = [
  //   { id: 1, status: "done" },
  //   { id: 2, status: "done" },
  //   { id: 3, status: "done" },
  //   { id: 4, status: "skip" },
  //   { id: 5, status: "done" },
  //   { id: 6, status: "done" },
  //   { id: 7, status: "skip" },
  //   { id: 8, status: "done" },
  //   { id: 9, status: "done" },
  //   { id: 10, status: "done" },
  //   { id: 11, status: "skip" },
  //   { id: 12, status: "done" },
  //   { id: 13, status: "done" },
  //   { id: 14, status: "done" },
  // ];
  const colStart = StartDay % 7 === 0 ? 7 : StartDay;
  const dummyItems = colStart-1;

  const placeholders = Array.from({length: dummyItems}).map((_, index) => ({
    id: `placeholder-${index}`,
    status: "none",
  }))

  data = [...placeholders, ...data]

  const statusStyles = {
    "done": "border flex justify-center items-center rounded-full bg-[#24934F] w-7 h-7 print:bg-[#24934F] print:border-[#24934F] force-print-bg",
    "skip": "border rounded-full w-7 h-7 bg-gray-300 print:bg-gray-300 print:border-gray-300 force-print-bg",
    "none": "border rounded-full w-7 h-7 bg-transparent border-transparent print:bg-transparent print:border-transparent"
  }

  console.log(colStart);
  return (
    <div className="w-96 border bg-white rounded-2xl p-4 print:w-full print:max-w-md">
      <p className="font-bold text-black text-xl text-left">
        {ActivityName}
      </p>
      <div className="grid grid-cols-7 gap-3 text-gray-500 ">
        <p>Mo</p>
        <p>Tu</p>
        <p>We</p>
        <p>Th</p>
        <p>Fr</p>
        <p>Sa</p>
        <p>Su</p>
      </div>

      <div className="grid grid-cols-7 gap-3 mb-3 mt-2">
        {data.map(({ id, status }) => {
            return(
            <div
              key={id}
              className={`${statusStyles[status]}`}
            >
              {status === "done" ? <TiTick color="white" strokeWidth={0.0625} size={24} /> : ""}
            </div>
            )
        })}
      </div>
    </div>
  );
};
